<template>
  <div id="app">
    <mqtt></mqtt>
    <router-view></router-view>
    <comnoticebar></comnoticebar>
  </div>
</template>

<script>
import mqtt from './common/comMqttws.vue'
import comnoticebar from './common/comNoticeBar.vue'
export default {
  name: 'App',
  setup() {
    return {
    
    };
  },
  methods: {
    
  },
  components: {
    mqtt,
    comnoticebar
  },
  unmounted() {
    alert("app unmounted");
  },
  destroyed() {
    alert("app 已经被销毁");
  },
  beforeDestroy() {
    alert("app 即将被销毁");
  }
}
</script>

<style>
.popup {
  position: fixed;
  bottom: 1rem;
  right: 1rem;
  z-index: 11;
  background: red;
  display: block;
  height: 1rem;
  width: 1rem;
}
#app {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  background-color: #f7f8fa;
  position: relative;
}
</style>
